import { isNumeric } from '../../../js/app/react/validators';

export const validateAverageSpentPerMonth = averageSpent => () => {
  const errors = [];
  if (!isNumeric(averageSpent)) {
    errors.push('Please enter a numeric value');
  }
  if (averageSpent <= 0) {
    errors.push('Please enter a positive value');
  }
  return errors;
};

export default null;
